export const TopLogo = () => {
    return <img src={process.env.PUBLIC_URL + '/geek_logo2.png'} className='top__logo' alt='Geek Utopia cover logo' />
}